var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 10,
    viewBox: "0 0 250 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.9721V5.02651L118.963 7.85714C120.25 7.85714 119.028 6.62304 119.028 5C119.028 3.46713 120.309 2.14286 119.092 2.14286L0 4.9721Z",
    fill: "#DEC49C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.813 5C120.813 2.23858 122.687 0 124.999 0C127.312 0 129.186 2.23858 129.186 5C129.186 7.76142 127.312 10 124.999 10C122.687 10 120.813 7.76142 120.813 5Z",
    fill: "#DEC49C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 4.9721V5.02651L131.036 7.85714C129.748 7.85714 130.971 6.62304 130.971 5C130.971 3.46713 129.69 2.14286 130.907 2.14286L250 4.9721Z",
    fill: "#DEC49C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.8553e5056be22f0fd4cedb1fc915558b.svg";
export { ForwardRef as ReactComponent };